import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Alert, Box, Grid2 } from '@mui/material';
import Title from 'modules/Pricing/components/Title';
import { Field, Form } from 'react-final-form';
import { Label } from '../../styles';
import { usePriceGroup } from 'core/contexts/priceGroup';
import { SelectComponent } from '@utriper/core-ui';
import ActionButtons from '../ActionButtons';

const EditUnitForm = ({ priceGroupId, handleClose = () => {}, unitId }) => {
    const { t } = useTranslation();
    const translate = (key) => t(`price_group_id.edit_unit_form.${key}`);
    const { units, submittingPriceGroup, editUnit } = usePriceGroup();
    const unitsOptions = useMemo(() => {
        const unitType = units?.find((unit) => unit?.id === unitId)?.typeId;

        const options = units?.filter((unit) => unit?.typeId === unitType);

        return options;
    }, [units, unitId]);

    const canEdit = useMemo(() => unitsOptions?.length > 1, [unitsOptions]);

    const handleSubmit = async ({ unitId: newUnitId }) => {
        await editUnit(priceGroupId, unitId, newUnitId);
        handleClose();
    };

    const validateForm = (values) => {
        const errors = {};

        if (!Number.isFinite(values?.unitId)) {
            errors.unitId = translate('validate_form.unit_id');
        }

        return errors;
    };

    return (
        <Form
            key={`edit-price-group-form-units-${priceGroupId}-${unitId}`}
            initialValues={{ unitId }}
            onSubmit={handleSubmit}
            validate={validateForm}
            render={({ handleSubmit, form }) => (
                <form key={`edit-price-group-form-units-${priceGroupId}-${unitId}`} onSubmit={handleSubmit} noValidate>
                    <Box component="section" py={2}>
                        <Title title={translate('title')} description={translate('description')} />

                        {/* Form */}
                        <Grid2 container direction="column" justifyContent="flex-start" alignItems="flex-start" gap="8px" mt="24px">
                            <Grid2 container width="100%" direction="column" justifyContent="flex-start" alignItems="flex-start" gap="4px">
                                <Label>{translate('form.unit')}</Label>
                                <Field name="unitId" component={SelectComponent} values={unitsOptions} disabled={!canEdit} />
                            </Grid2>

                            {!canEdit && (
                                <Grid2 size={12}>
                                    <Alert severity="warning">{translate('form.warning')}</Alert>
                                </Grid2>
                            )}
                        </Grid2>

                        <ActionButtons
                            handleSubmit={(e) => {
                                return handleSubmit(e);
                            }}
                            handleClose={(e) => {
                                handleClose();
                                return form.reset(e);
                            }}
                            disabled={!canEdit}
                            submitting={submittingPriceGroup}
                            labelNext={translate('edit_button')}
                        />
                    </Box>
                </form>
            )}
        />
    );
};

export default EditUnitForm;
